const React = require('react');
const ReactDOM = require('react-dom');
const { Provider } = require('react-redux');
const { configureStore } = require('./src/redux/store');
const loadableReady = require('@loadable/component').loadableReady;
const store = configureStore();
exports.onClientEntry = () => {
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  // if (typeof window.IntersectionObserver === `undefined`) {
  //   import(`intersection-observer`);
  //   console.log(`# IntersectionObserver is polyfilled!`);
  // }
};
exports.wrapRootElement = ({ element }) => {
  return <Provider store={store}>{element}</Provider>;
};

exports.replaceHydrateFunction = () => {
  return (element, container, callback) => {
    loadableReady(() => {
      // const renderMethod = !module.hot ? ReactDOM.render : ReactDOM.hydrate
      const renderMethod = ReactDOM.render;
      renderMethod(element, container, callback)
      //  ReactDOM.render(element, container, callback);
    });
  };
};